import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'aga-medicine-list-dialog',
  templateUrl: './medicine-list-dialog.component.html',
  styleUrl: './medicine-list-dialog.component.scss'
})
export class MedicineListDialogComponent implements OnInit {
	isWarning: boolean;
	message: string;
	innerHtml: string;
	leftButtonText: string;
	rightButtonText: string;
	hideRightButton: boolean;
	hideLeftButton: boolean;
	invertButtonColors: boolean;
	onLeftButtonClick: Function;
	onRightButtonClick: Function;
  medicines: Array<any>;

	constructor(
    private translateService: TranslateService
  ) {}

	ngOnInit(): void {
		if (!this.leftButtonText) {
			this.leftButtonText = this.translateService.instant('genericButtons.no');
		}
		if (!this.rightButtonText) {
			this.rightButtonText = this.translateService.instant('genericButtons.yes');
		}
	}
}
